function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes, { node } from 'prop-types';
import classNames from '../utils/classNames';
/**
 * Vertically aligns elements to the given line-height associated with a font-style,
 * without taking up any additional space. This is helpful for elements which are larger than
 * the text that is trying to be aligned and if the alignment is to apply to only the
 * first line of text
 */

var AlignToText = /*#__PURE__*/function (_PureComponent) {
  _inherits(AlignToText, _PureComponent);

  var _super = _createSuper(AlignToText);

  function AlignToText() {
    _classCallCheck(this, AlignToText);

    return _super.apply(this, arguments);
  }

  _createClass(AlignToText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          fontStyle = _this$props.fontStyle,
          spacer = _this$props.spacer,
          children = _this$props.children,
          position = _this$props.position;
      if (!children) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor', className),
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames("psw-l-h-".concat(fontStyle), 'psw-l-line-left', 'psw-hidden', 'psw-clip')
      }, spacer || children), /*#__PURE__*/React.createElement("div", {
        className: "psw-l-anchor-".concat(position, " psw-l-").concat(position, " psw-l-inline")
      }, children));
    }
  }]);

  return AlignToText;
}(PureComponent);

AlignToText.defaultProps = {
  className: '',
  fontStyle: 'title-m',
  children: node,
  position: 'center-right',
  spacer: null
};
AlignToText.propTypes = {
  /**
   * The markup to apply the alignment too. The elements will be taken out of the document flow and
   * will need to be accounted for with the `spacer` prop
   */
  children: PropTypes.node,

  /**
   * Additional css classes to apply to the component
   */
  className: PropTypes.string,

  /**
   * The DIG 20 font style token to use as the basis for the alignment (line-height)
   */
  fontStyle: PropTypes.oneOf(['mega', 'title-l', 'title-m', 'title-s', 'subtitle', 'overline', 'body', 'secondary', 'utility']),

  /**
   * How to position the provided elements with respect to the text anchor
   */
  position: PropTypes.oneOf(['top-left', 'top-center', 'top-right', 'center-left', 'center', 'center-right', 'bottom-left', 'bottom-center', 'bottom-right']),

  /**
   * Spacer node to account for the space of the positioned elements
   */
  spacer: PropTypes.node
};
export default AlignToText;